// extracted by mini-css-extract-plugin
module.exports = {"title":"title-1tNeH5Er","titleList":"titleList-22fFSJtW"};